const MESSAGES_DOMAIN = 'messages'

const MESSAGES_KEY = {
  ALL: 'all',
  DATA: 'data',
  BY_CHAT_ID: 'byChatId',
  CURRENT: 'current'
}

const MESSAGES_PATH = {
  ALL: `${MESSAGES_DOMAIN}.${MESSAGES_KEY.ALL}`,
  ALL_DATA: `${MESSAGES_DOMAIN}.${MESSAGES_KEY.ALL}.data`,
  DATA: `${MESSAGES_DOMAIN}.${MESSAGES_KEY.DATA}`,
  BY_CHAT_ID: `${MESSAGES_DOMAIN}.${MESSAGES_KEY.BY_CHAT_ID}`,
  CURRENT: `${MESSAGES_DOMAIN}.${MESSAGES_KEY.CURRENT}`
}

const MESSAGES_STATE = {
  [MESSAGES_KEY.ALL]: {
    data: [],
    status: null
  },
  [MESSAGES_KEY.CURRENT]: null,
  [MESSAGES_KEY.DATA]: {},
  [MESSAGES_KEY.BY_CHAT_ID]: {}
}

const MESSAGES_ANALYTIC_EVENT = {
  SEND_MESSAGE: 'SEND_MESSAGE',
  MARK_AS_READ: 'MARK_AS_READ'
}

const MESSAGES_EVENT_CATEGORY = 'CHAT'

const MESSAGES_ACTION = {
  CREATE: 'MESSAGES_CREATE',
  CLOSE: 'MESSAGES_CLOSE',
  ADD_REPLY: 'MESSAGES_ADD_REPLY',
  LOAD: 'MESSAGES_LOAD',
  LOAD_BY_ID: 'MESSAGES_LOAD_BY_ID',
  SAVE: 'MESSAGES_SAVE',
  UPDATE_CURRENT: 'MESSAGES_UPDATE_CURRENT',
  MARK_AS_READ: 'MESSAGES_MARK_AS_READ',
  UPDATE_MESSAGE: 'MESSAGES_UPDATE_MESSAGE',
  UPDATE_READ_AT: 'MESSAGES_UPDATE_READ_AT',
  DELETE_CURRENT: 'MESSAGES_DELETE_CURRENT',
  UPDATE: 'MESSAGES_UPDATE',
  DELETE: 'MESSAGES_DELETE',
  ADD_TO_BY_CHAT_ID: 'ADD_TO_BY_CHAT_ID'
}

const ROOT = '/messages'
const MESSAGES_ENDPOINT = {
  ROOT,
  MARK_AS_READ: `${ROOT}/mark-as-read`
}

export {
  MESSAGES_DOMAIN,
  MESSAGES_KEY,
  MESSAGES_PATH,
  MESSAGES_STATE,
  MESSAGES_ANALYTIC_EVENT,
  MESSAGES_ACTION,
  MESSAGES_ENDPOINT,
  MESSAGES_EVENT_CATEGORY
}
